'use client';

import { createContext, PropsWithChildren, useContext } from 'react';
import usePageFiltersState, { IUsePageFiltersState } from './usePageFiltersState';

const PageFiltersStateContext = createContext<IUsePageFiltersState | null>(null);

export const usePageFiltersStateContext = (): IUsePageFiltersState => {
  const context = useContext(PageFiltersStateContext);

  if (!context) {
    throw new Error('usePageFiltersStateContext must be used within a PageFiltersStateContextProvider');
  }

  return context;
};

const PageFiltersStateContextProvider = ({ children }: PropsWithChildren) => (
  <PageFiltersStateContext.Provider value={ usePageFiltersState() }>
    { children }
  </PageFiltersStateContext.Provider>
);

export default PageFiltersStateContextProvider;
